export enum LastUpdateDaysCellBlock {
  Root = 'LastUpdateDaysCell',
}
